module.exports = __webpack_public_path__ + "static/about-us-hero-image@2x-60aac1e5e381872be8b063bcf429780b.jpg";